/* eslint-disable @typescript-eslint/no-shadow */
import { Action } from '@ngrx/store';

export enum ActionTypes {
    Refresh             = '[App] - Refresh',
}

export class Refresh implements Action {
    readonly type = ActionTypes.Refresh;
}
